import cacheLs from "../cacheLs"

export default {
  addEventState (state, data) {
    state.selectedeventstate = { ...data }
    cacheLs.set_event_state(data)
  }
}
